import script from "./ResourceTableColumn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourceTableColumn.vue?vue&type=script&lang=ts&setup=true"

import "./ResourceTableColumn.vue?vue&type=style&index=0&id=e36b5c08&scoped=true&lang=css"

import exportComponent from "/builds/n-Zh5gRSP/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e36b5c08"]])

export default __exports__